<template>
	<div class="index_body" id="top" :class="isPhone == 'true' ? 'mobile' : ''" >
		<head-nav></head-nav>
		<div class="banner"><img src="@comm/images/document-conversion/banner_aboutus.png" /></div>
		<div class="main">
			<div class="about_box">
				<!-- <div class="introductionn_nav">
					<a
					v-for="(item, index) in nav"
					:key="index"
					:href="'#' + item.id"
					class="item"
					:class="{ active: currentIndex == index }"
					@click="chooseNav(index)"
					>{{ item.name }}
					</a>
				</div> -->
				<div class="introductionn" id="introductionn">
					<div class="box">
						<h2>公司简介</h2>
						<div class="fonts">
							<img src="@comm/images/document-conversion/gongsi_pic.png" />
							<div class="jianjie">
								<h4>北京数科网维技术有限责任公司</h4>
								<h5>民族自主文档格式标准的倡导者和践行者，致力于打造最适合公务应用的系列标准化版式文档处理软件。</h5>
								<p>
									北京数科网维技术有限责任公司成立于2006年，公司专注于版式技术研发和信息化应用，是国内主要的专业版式文档处理产品和技术服务提供商。数科网维是OFD国家版式标准的主要编制单位之一，也是党政机关电子公文标准规范等一系列国家电子文件相关标准的参编单位。长期以来，数科的版式技术创新成果应用于电子公文、数字档案、电子证照、电子票据、数字出版等行业等领域，获得广泛认可。
								</p>
								<a href="http://suwell.cn/" target="_blank">前往数科网维官网了解更多 >></a>
							</div>
						</div>
					</div>
				</div>
				<div class="overview" id="overview">
					<div class="box">
						<h2>产品概述</h2>
						<p>
							数科OFD云服务体验中心（<a href="http://www.ofd.cn" target="_blank">www.ofd.cn</a
							>）是由数科网维推出的在线云文档服务。数科OFD云服务包含文档专业处理中心、格式转换中心、发票管理平台、安全保密中心、云端协同办公、OCR在线识别六大功能模块。覆盖了OFD全生命周期的应用需要，<strong>一站式文档处理+安全保护+协同办公平台</strong>，是OFD格式文档的最佳应用选择。
						</p>
						<ul>
							<li>
								<img src="@comm/images/document-conversion/about_icon_01.svg" />
								<h3>文档专业处理中心</h3>
								<p>提供OFD文档在线预览、文档拆分、文档合并、文档压缩等文档处理功能。</p>
							</li>
							<li>
								<img src="@comm/images/document-conversion/about_icon_02.svg" />
								<h3>格式转换中心</h3>
								<p>提供OFD格式与常见文档格式间的互转功能，且支持批量转换。</p>
							</li>
							<li>
								<img src="@comm/images/document-conversion/about_icon_03.svg" />
								<h3>发票管理平台</h3>
								<p>提供OFD发票在线生成、在线查看、在线验证、数据提取等功能。</p>
							</li>
							<li>
								<img src="@comm/images/document-conversion/about_icon_04.svg" />
								<h3>安全保密中心</h3>
								<p>提供对OFD文档进行加密、解密以及添加水印等保障文档安全的功能。</p>
							</li>
							<li>
								<img src="@comm/images/document-conversion/about_icon_05.svg" />
								<h3>云端协同办公</h3>
								<p>数科OFD云服务将与数科OFD其他产品云端互联，同时提供文档签批等协同办公的功能。</p>
							</li>
							<li>
								<img src="@comm/images/document-conversion/about_icon_06.svg" />
								<h3>OCR在线识别</h3>
								<p>提供对OFD、PDF、图片进行OCR在线识别功能，智能高效识别文档内容。</p>
							</li>
						</ul>
					</div>
				</div>
				<!-- <div class="honor" id="honor">
					<img src="@comm/images/document-conversion/honor_bj.png" class="bj" />
					<div class="box">
						<h2>行业领先</h2>
						<div class="fonts">
							<div class="left">
								<h4>四个“第一”</h4>
								<p><strong>中国的第一篇OFD电子公文、第一张OFD电子证照、第一张OFD电子发票、第一份OFD电子病历</strong>都是由数科软件产品制作和处理的。</p>
								<p>目前，数科产品<strong>市场占有率超过85%</strong>，也是我国唯一成功出口海外的OFD产品，在市场中拥有很高的声誉和口碑。</p>
							</div>
							<div class="right">
								<img src="@comm/images/document-conversion/ipad_bj.png" class="honor_bj" />
								<div class="swiper_box">
									<swiper :options="swiperOption" ref="mySwiper">
										<swiper-slide><img src="@comm/images/document-conversion/swiper_01.png" /></swiper-slide>
										<swiper-slide><img src="@comm/images/document-conversion/swiper_02.png" /></swiper-slide>
										<swiper-slide><img src="@comm/images/document-conversion/swiper_03.png" /></swiper-slide>
										<swiper-slide><img src="@comm/images/document-conversion/swiper_04.png" /></swiper-slide>
									</swiper>
									
									<div class="swiper-button-next"></div>
									<div class="swiper-button-prev"></div>
								</div>
								<div class="currentSwiper">
									<div class="item" :class="{ active: activeIndex == index }" v-for="(item, index) in swiperNav" :key="index" @click="clickNav(index)">
										{{ item }}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div> -->
				<div class="scenario" id="scenario">
					<div class="box">
						<h2>应用场景</h2>
						<ul>
							<li>
								<img src="@comm/images/document-conversion/about_icon_07.svg" />
								<h3>电子公文</h3>
								<div class="item_box">
									<div class="item">公文成文<span>公文批注</span></div>
									<div class="item">公文存储<span>公文阅读</span></div>
									<div class="item">公文签章<span>公文归档</span></div>
									<div class="item">公文交换<span>公文校验</span></div>
								</div>
							</li>
							<li>
								<img src="@comm/images/document-conversion/about_icon_08.svg" />
								<h3>电子档案</h3>
								<div class="item_box">
									<div class="item">纸质档案电子化</div>
									<div class="item">标准格式转换</div>
									<div class="item">跨平台共享阅读</div>
									<div class="item">安全离线借阅</div>
								</div>
							</li>
							<li>
								<img src="@comm/images/document-conversion/about_icon_09.svg" />
								<h3>电子证照</h3>
								<div class="item_box">
									<div class="item">证照制作</div>
									<div class="item">证照管理</div>
									<div class="item">证照验证</div>
									<div class="item">证照查询</div>
								</div>
							</li>
							<li>
								<img src="@comm/images/document-conversion/about_icon_10.svg" />
								<h3>电子票据</h3>
								<div class="item_box">
									<div class="item">发票生成</div>
									<div class="item">发票查看</div>
									<div class="item">发票查验</div>
									<div class="item">数据提取</div>
								</div>
							</li>
						</ul>
					</div>
				</div>
				<div class="callUs" id="callUs">
					<div class="box">
						<h2>联系我们</h2>
						<map-api></map-api>
						<div class="address_box">
							<div class="item">
								<h2>北京总部：</h2>
								<p>北京市海淀区车道沟1号青东商务区A座东7层<span>100089</span></p>
							</div>
							<div class="item">
								<h2>联系渠道：</h2>
								<p>服务电话：400-677-5005<span>服务邮箱：wps@wps.cn</span></p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<customer-service></customer-service>
		<footer-nav></footer-nav>
	</div>
</template>

<script>
import footerNav from "@comm/components/document-conversion/footerPage";
import headNav from "@comm/components/document-conversion/headerPage";
import customerService from "@comm/components/document-conversion/customerService";
import mapApi from "@comm/components/document-conversion/map";
export default {
	components: { footerNav, customerService, headNav, mapApi },
	name: "index",
	data() {
		return {
			isPhone: false,
			nav: [
				{ name: "公司简介", id: "introductionn" },
				{ name: "产品概述", id: "overview" },
				{ name: "行业荣誉", id: "honor" },
				{ name: "应用场景", id: "scenario" },
				{ name: "联系我们", id: "callUs" }
			],
			currentIndex: 0,
			listBoxState: true, //点击导航栏时，暂时停止监听页面滚动
			activeIndex: 0,
			swiperNav: ["OFD电子发票", "OFD电子公文", "OFD电子证照", "OFD电子病历"],
			swiperOption: {
				// loop: true, // 循环模式选项
				autoplay: {
					delay: 3000,
					disableOnInteraction: false
				}, // 自动播放
				speed: 1000, // 切换速度
				effect: "slide", // 动画 fade cube slide coverflow flip
				observer: true, //修改swiper自己或子元素时，自动初始化swiper
				observeParents: true, //修改swiper的父元素时，自动初始化swiper
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev"
				},
				on: {
					slideChange: () => {
						let swiper = this.$refs.mySwiper.swiper;
						let activeIndex = swiper.activeIndex;
						this.activeIndex = activeIndex;
					}
				}
			}
		};
	},
	created() {
		this.isPhone = localStorage.getItem("isPhone");
		document.title = "关于我们";
	},
	mounted() {
		// window.addEventListener("scroll", this.listenerScroll, true);
	},
	beforeDestroy() {
		// window.removeEventListener("scroll", this.listenerScroll, true);
	},
	watch: {
	},
	computed: {
		swiper: function () {
			return this.$refs.mySwiper.swiper;
		}
	},
	methods: {
		listenerScroll() {
			let timeId;
			let that = this;
			// 页面滚动停止100毫秒后才会执行下面的函数。
			clearTimeout(timeId);
			timeId = setTimeout(() => {
				that.scrollToTop();
			}, 100);
		},
		clickNav(index) {
			this.activeIndex = index;
			this.swiper.slideTo(this.activeIndex, 1000, false);
		},
		chooseNav(index) {
			let that = this;
			this.currentIndex = index;
			this.listBoxState = false;

			let timeId;
			clearTimeout(timeId);
			timeId = setTimeout(() => {
				that.listBoxState = true;
			}, 200);
		},
		scrollToTop() {
			// 获取视窗高度
			var domHight = document.body.offsetHeight;
			// dom滚动位置
			var scrollTop = document.getElementById("app").scrollTop;
			if (this.listBoxState) {
				//作用是点击导航栏时，延迟这里执行。
				this.nav.map((v, i) => {
					// 获取监听元素距离视窗顶部距离
					let id = this.nav[i].id;
					var offsetTop = document.getElementById(id).offsetTop;
					// 获取监听元素本身高度
					var scrollHeight = document.getElementById(id).scrollHeight;
					// 如果 dom滚动位置 >= 元素距离视窗距离 && dom滚动位置 <= 元素距离视窗距离+元素本身高度
					// 则表示页面已经滚动到可视区了。
					if (scrollTop >= offsetTop && scrollTop <= offsetTop + scrollHeight) {
						// 导航栏背景色选中
						this.currentIndex = i;
					}
				});
			}
		}
	}
};
</script>
<style lang="scss" scoped>
.index_body {
	width: 100%;
	padding-top: 72px;
	.banner img {
		width: 100%;
		height: auto;
	}
	.main {
		width: 100%;
		background: url("../../comm/images/document-conversion/about_bj.png") 0 0 no-repeat;
		background-size: 958px 756px;
		h2,
		h3,
		h4,
		h5,
		p,
		ul {
			margin: 0;
		}
	}
	.about_box {
		position: relative;
		.introductionn_nav {
			width: 148px;
			// box-shadow: 0px 0px 10px 4px rgba(0, 0, 0, 0.12);
			display: flex;
			flex-direction: column;
			position: fixed;
			top: 65%;
			left: 7%;
			background: #fff;
			z-index: 9;
			.item {
				width: 100%;
				padding-left: 24px;
				height: 54px;
				line-height: 54px;
				font-size: 16px;
				font-weight: 400;
				color: #36425a;
				&:hover {
					background: #f8f8f8;
					text-decoration: none;
				}
				&:focus,
				&.active {
					background: #fff;
					border-left: 2px #14a8f0 solid;
					color: #14a8f0;
				}
			}
		}
		.box {
			width: 1200px;
			margin: 0 auto;
		}

		h2 {
			text-align: center;
			font-size: 32px;
			font-weight: 400;
			color: #242f44;
			line-height: 45px;
			padding: 80px 0 64px;
		}
		.callUs{
			h2{
				padding-top: 0;
			}
		}
		.introductionn {
			padding-bottom: 80px;
			.fonts {
				display: flex;
				align-items: flex-start;
				img {
					width: 390px;
					height: 280px;
				}
				.jianjie {
					flex: 1;
					color: #36425a;
					line-height: 28px;
					padding-left: 19px;
					h4 {
						font-size: 22px;
						font-weight: 600;
						line-height: 28px;
					}
					h5 {
						font-size: 16px;
						font-weight: 600;
						line-height: 28px;
						margin-bottom: 38px;
						padding-top: 4px;
					}
					p {
						height: 160px;
						font-size: 16px;
						font-weight: 400;
						line-height: 32px;
						text-indent: 30px;
					}
					a {
						font-size: 16px;
						font-weight: 400;
						color: #14a8f0;
						line-height: 22px;
						float: right;
						text-decoration: underline;
					}
				}
			}
		}
		.overview {
			background: rgba(247, 249, 252, 0.69);
			h2 {
				padding-top: 64px;
			}
			p {
				font-size: 16px;
				font-weight: 400;
				color: #36425a;
				line-height: 32px;
				margin-bottom: 64px;
				text-indent: 30px;
				a,
				a:hover,
				a:focus {
					color: #14a8f0;
					text-decoration: underline;
				}
			}
			ul {
				padding: 0 69px;
				display: flex;
				justify-content: space-between;
				align-items: flex-start;
				flex-wrap: wrap;
				li {
					width: 244px;
					margin-bottom: 37px;
					&:nth-child(2),
					&:nth-child(5) {
						margin: 0 50px;
					}
					img {
						width: 64px;
						height: 64px;
					}
					h3 {
						font-size: 22px;
						font-weight: 400;
						color: #36425a;
						line-height: 28px;
						padding: 16px 0;
					}
					p {
						font-size: 14px;
						font-weight: 400;
						color: #8b97af;
						line-height: 22px;
						height: 108px;
						margin: 0;
						text-indent: 0;
					}
				}
			}
		}
		.honor {
			position: relative;
			.bj {
				position: absolute;
				top: 32px;
				left: 0;
				width: 100%;
				height: auto;
				z-index: -1;
			}
			h2 {
				padding-bottom: 0;
			}
			.fonts {
				display: flex;
				align-items: flex-start;
				justify-content: space-between;
				margin-top: 32px;
				.left {
					width: 551px;
					font-size: 16px;
					font-weight: 400;
					color: #36425a;
					line-height: 32px;
					padding-top: 135px;
					h4 {
						font-size: 24px;
						font-weight: 600;
						color: #242f44;
						line-height: 33px;
						margin-bottom: 32px;
						text-align: center;
					}
					p {
						text-indent: 30px;
					}
				}
				.right {
					width: 611px;
					display: flex;
					align-items: flex-start;
					position: relative;
					.honor_bj {
						width: 611px;
						height: 431px;
						position: absolute;
						top: 0;
						left: 0;
					}
					.swiper_box {
						width: 405px;
						height: 265px;
						margin-left: 76px;
						margin-top: 120px;
						position: relative;
						border-radius: 4px;
						box-shadow: 0 5px 10px 0px rgba(110, 110, 110, 0.3);
						overflow: hidden;
						.swiper-container {
							.swiper-slide {
								width: 100% !important;
							}
						}
						.swiper-button-prev {
							width: 56px;
							height: 57px;
							left: -6px;
							background: url("../../comm/images/document-conversion/swiper_left.png") 0 0 no-repeat;
							background-size: 100%;
							outline: none;
						}
						.swiper-button-next {
							width: 56px;
							height: 57px;
							right: -6px;
							background: url("../../comm/images/document-conversion/swiper_right.png") 0 0 no-repeat;
							background-size: 100%;
							outline: none;
						}
					}
					.currentSwiper {
						width: 405px;
						text-align: center;
						position: absolute;
						bottom: -75px;
						left: 76px;
						.item {
							width: 100%;
							display: none;
							font-size: 18px;
							font-weight: 600;
							color: #36425a;
							line-height: 25px;
							&.active {
								display: block;
							}
						}
					}
				}
			}
		}
		.scenario {
			// background: #f9fbfd;
			// margin-top: 160px;
			padding-bottom: 64px;
			h2 {
				padding-top: 64px;
			}
			ul {
				display: flex;
				align-items: center;
				justify-content: space-between;
				li {
					background: #fff;
					width: 288px;
					height: 288px;
					border-radius: 4px;
					border: 1px solid rgba(0, 0, 0, 0.08);
					display: flex;
					flex-direction: column;
					align-items: center;
					padding: 24px 28px 28px;
					&:hover {
						box-shadow: 0px 0px 20px 7px rgba(0, 0, 0, 0.12);
					}
					img {
						width: 64px;
						height: 64px;
					}
					h3 {
						padding: 8px 0 16px;
						font-size: 18px;
						font-weight: 600;
						color: #383e45;
						line-height: 28px;
					}
					.item_box {
						width: 100%;
						border-top: 1px solid #d5d5d5;
						padding-top: 8px;
						.item {
							text-align: center;
							width: 100%;
							padding: 8px 28px 0;
							font-size: 14px;
							font-weight: 400;
							color: #8b97af;
							line-height: 22px;
							span {
								padding-left: 60px;
							}
						}
					}
				}
			}
		}
		.address_box {
			margin: 16px 0 80px;
			display: flex;
			justify-content: space-between;
			align-items: center;
			.item {
				width: 592px;
				height: 136px;
				background: #f7f9fc;
				padding: 27px 16px 31px;
				margin: 0;
				h2 {
					font-size: 26px;
					font-weight: 400;
					color: #36425a;
					line-height: 32px;
					margin-bottom: 27px;
					padding: 0;
					text-align: left;
				}
				p {
					font-size: 18px;
					font-weight: 400;
					color: #383e45;
					line-height: 22px;
					span {
						padding-left: 47px;
					}
				}
			}
		}
	}
}
</style>




// WEBPACK FOOTER //
// src/supubwps-document-conversion/pages/aboutUs.vue